var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderNavBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 765,
    height: 52,
    viewBox: "0 0 765 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Progress_Line",
    x: 0,
    y: 0,
    width: 300,
    height: 31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slider_Nav_Bottom",
    "data-name": "Slider Nav Bottom",
    transform: "translate(15 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Slide_1",
    "data-name": "Slide 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Progress_Line_Full",
    "data-name": "Progress Line Full",
    width: 360,
    height: 1,
    rx: 0.5,
    fill: "#709be7",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -10)",
    filter: "url(#Progress_Line)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Progress_Line-2",
    "data-name": "Progress Line",
    width: 270,
    height: 1,
    rx: 0.5,
    transform: "translate(15 10)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Lorem_ipsum_dollor_sit_amet",
    "data-name": "Lorem ipsum dollor sit amet",
    transform: "translate(0 38)",
    fill: "#8a909f",
    fontSize: 18,
    fontFamily: "Ubuntu",
    letterSpacing: "-0.028em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Slide_2",
    "data-name": "Slide 2",
    transform: "translate(390)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Consecteteur_sit_amet_lorem_ipsum",
    "data-name": "Consecteteur sit amet lorem ipsum",
    transform: "translate(0 38)",
    fill: "#8a909f",
    fontSize: 18,
    fontFamily: "Ubuntu",
    letterSpacing: "-0.028em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Progress_Line_Full-2",
    "data-name": "Progress Line Full",
    width: 360,
    height: 1,
    rx: 0.5,
    fill: "#fcfcfd",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderNavBottom);
export default __webpack_public_path__ + "static/media/slider_nav_bottom.b9b3ba5d363a859149d19ed2460b7c68.svg";
export { ForwardRef as ReactComponent };